webpackJsonp([233405211396040],{

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/Damodaran.png";
	var icon2 = "https://winpeforum.com/assets/elements/RadhikaHaribhakti.jpg";
	var icon3 = "https://winpeforum.com/assets/elements/AshuSuyash.jpg";
	
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/wob/11sep2025/1.png";
	var I2 = "https://www.winpeforum.com/assets/wob/11sep2025/2.png";
	var I3 = "https://www.winpeforum.com/assets/wob/11sep2025/3.png";
	var I4 = "https://www.winpeforum.com/assets/wob/11sep2025/4.png";
	var I5 = "https://www.winpeforum.com/assets/wob/11sep2025/5.png";
	var I6 = "https://www.winpeforum.com/assets/wob/11sep2025/6.png";
	var I7 = "https://www.winpeforum.com/assets/wob/11sep2025/7.png";
	var I8 = "https://www.winpeforum.com/assets/wob/11sep2025/8.png";
	var I9 = "https://www.winpeforum.com/assets/wob/11sep2025/9.png";
	var I10 = "https://www.winpeforum.com/assets/wob/11sep2025/10.png";
	var I11 = "https://www.winpeforum.com/assets/wob/11sep2025/11.png";
	var I12 = "https://www.winpeforum.com/assets/wob/11sep2025/12.png";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/1.png";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/2.png";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/3.png";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/4.png";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/5.png";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/6.png";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/7.png";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/8.png";
	var II9 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/9.png";
	var II10 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/10.png";
	var II11 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/11.png";
	var II12 = "https://www.winpeforum.com/download.php?file=assets/wob/11sep2025/12.png";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon3,
	      desc: "<div>\n    Ashu Suyash is a seasoned leader with over 30 years of experience across Indian financial services and\nglobal information sectors. She is the Founder &amp; CEO of Colossa Ventures, an investment platform\nempowering women-led businesses with capital, capability, and confidence.<Br/><br/>\nShe serves as an independent director on the boards of Hindustan Unilever, Kotak Mahindra Bank, and\nTata Elxsi.<br/><br/>\nAshu is a strong sponsor of governance and best practices, and cares deeply about economic agency for\nwomen, affordable healthcare and right to education for all. She is a member of several Associations and\nCommittees in these areas. Ashu has received several awards and has been recognised among the Top\n50 Women in business in India. She is a Chartered Accountant and holds a bachelor&#39;s degree in\ncommerce from University of Mumbai.\n          </div>",
	      name: "Ashu Suyash",
	      post: "<div>Director on Boards\n          </div>"
	    }, {
	      imgUrl: icon1,
	      desc: "<div>\nM. Damodaran, IAS (Retd.), presently a governance consultant, advisor, mentor and coach, has worked\nwith the Union and the State governments in India, regulatory bodies, investment institutions, banks,\ndevelopment financial institutions and with the private sector. He has headed the highly successful\nrestructuring efforts in Unit Trust of India (UTI) and Industrial Development Bank of India (IDBI). He has\nbeen the Chairman of Securities and Exchange Board of India (SEBI). During his tenure at SEBI, he was\nelected Chairman of the EMC of the International Organisation of Securities Commission (IOSCO).\nHe has chaired high powered committees of the Government of India, Reserve Bank of India (RBI) and\nsome chambers of commerce. He has won several awards, including some for governance, leadership\nand transformation. He has been on the Boards of some of India\u2019s biggest companies and on the\n \nAdvisory Boards of some foreign entities and is the Founder Chairman of Indian Institute of Management\n(IIM), Tiruchirappalli. He graduated with distinction in Economics and in Law from the Universities of\nMadras and Delhi respectively. He is widely acknowledged as one of India\u2019s foremost champions of\nCorporate Governance and is passionate about improving Board performance.\n \n          </div>",
	      name: "M. Damodaran",
	      post: "<div>Founder & Chairperson<br/> Excellence Enablers\n\n          </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n    Radhika Haribhakti has over 30 years of experience in commercial and investment banking, having\nworked with Bank of America, JM Morgan Stanley, and DSP Merrill Lynch. She has advised several giant\ncorporates and led their equity and debt offerings in domestic and international capital markets. She\ncurrently provides advisory services at RH Financial.\xA0<br/><br/>\nShe serves as an Independent Director on the Boards of Torrent Power, Bajaj Finance, Bajaj Finserv,\nICRA, NOCIL, and Data Link Investment Manager.<br/><br/>\n\nRadhika Haribhakti has been closely associated with women empowerment and financial inclusion and\nhas over 18 years of experience serving on non-profit boards. She is the former Chair of Friends of\nWomen&#39;s World Banking (FWWB) and Swadhaar FinAccess, two non-profits engaged in providing\nfinancial solutions to women in economically disadvantaged communities. She also previously served on\nthe Governing Council of Citigroup Micro Enterprise Award and CIl&#39;s National Committee on Women\nEmpowerment.\n          </div>",
	      name: "Radhika Haribhakti",
	      post: "<div>Director on Boards\n          </div>"
	    }];
	
	    _this.Speaker2 = [{
	      imgUrl: icon2,
	      desc: "Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.\n<br/><br/>\nAt McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.\n\n\n         ",
	      name: "Alka Goel",
	      post: "<div>Founding Partner<br/> Alkemi Growth Capital\n        </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I2, ImgSrc1: II2 }, { id: 22, ImgSrc: I3, ImgSrc1: II3 }, { id: 19, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 34, ImgSrc: I6, ImgSrc1: II6 }, { id: 23, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }, { id: 22, ImgSrc: I9, ImgSrc1: II9 }, { id: 19, ImgSrc: I10, ImgSrc1: II10 }, { id: 35, ImgSrc: I11, ImgSrc1: II11 }, { id: 34, ImgSrc: I12, ImgSrc1: II12 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Women on Boards",
	        image: "https://winpeforum.com/assets/wob/banner.jpg",
	        description: "Winpe\u2019s Women on Boards initiative successfully hosted its first Boardroom Excellence Session on 11th September 2025 at Taj Lands End, Mumbai. ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Module 1:\xA0Board Foundations & Leadership  "
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "September 11, 2025 (10:00 - 5:00 PM IST)",
	                  _react2.default.createElement("br", null),
	                  "Taj Lands End, Mumbai"
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "Winpe\u2019s Women on Boards initiative successfully hosted its first Boardroom Excellence Session on ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "11th September 2025 at Taj Lands End, Mumbai"
	              ),
	              ". Aimed at equipping senior women professionals with the knowledge, skills, and networks needed to excel in board roles, the session created a powerful platform for learning and peer exchange, combining practical governance insights with opportunities for personal development and advocacy.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The program seamlessly blended practical governance insights with opportunities for peer learning, personal growth, and advocacy, creating an engaging platform that empowered participants to step into board rooms with confidence and impact. Participants left the session with practical knowledge of board functioning, governance best practices, and insights from faculty to strengthen effectiveness. Key takeaways included handling dissent constructively, distinguishing the roles of Boards and Management, asking the right questions, staying updated on regulations, and prioritizing ESG governance. The programme concluded with an interactive workshop, where candid exchanges and reflections from speakers created a trusted environment for open dialogue and meaningful learning.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The session saw a full house with 28 accomplished women from the corporate and investment community. The session received a 100% score on knowledge gains and our stalwart faculty a perfect 5.0 rating. Participants valued the practical governance insights, peer networking, and personal growth that they received and appreciated the Women on Boards platform for its concept, content, and community.",
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                    "Speakers"
	                  ),
	                  "          ",
	                  _react2.default.createElement("div", { "class": "r_btm" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Our_Speakers container" },
	                    _react2.default.createElement(
	                      "center",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Speakers_img", style: { width: '100%', margin: '0' } },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          this.Speaker1.map(function (item, i) {
	                            if (i <= 3) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "main_speaker_card col-md-4 col-sm-12 col-lg-4",
	                                  key: i
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "Scardd" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "s_img",
	                                      onClick: function onClick() {
	                                        return _this3.togglePopUp(item);
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "center",
	                                      null,
	                                      "  ",
	                                      _react2.default.createElement("img", {
	                                        src: item.imgUrl,
	                                        alt: item.name,
	                                        className: "img-responsive",
	                                        style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement("br", null),
	                                  "    ",
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_name",
	                                    dangerouslySetInnerHTML: { __html: item.name }
	                                  }),
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_post",
	                                    dangerouslySetInnerHTML: { __html: item.post }
	                                  })
	                                )
	                              );
	                            } else return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Heading2.default, { title: "Gallery" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.CollegiumsImages.map(function (item, j) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-4 col-sm-6 col-xs-12", style: { padding: '8px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img_card" },
	                      _react2.default.createElement("img", { style: { width: '100%' }, src: item.ImgSrc, alt: "Winpe sheshines" }),
	                      _react2.default.createElement(
	                        "a",
	                        { href: item.ImgSrc1 },
	                        " ",
	                        _react2.default.createElement("i", { style: { color: 'white', position: 'absolute', left: '20px', top: '20px' }, "class": "fa fa-2x  fa-download " })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "i",
	                null,
	                "Winpe\u2019s Women on Boards initiative revolutionizes board leadership by advancing the inclusion of elite, board-ready women executives. Collaborating with progressive corporates, it delivers curated talent pipelines, rigorous board-readiness frameworks, and bespoke engagement models to enhance governance and drive DEI mandates. By unleashing diverse leadership potential, the initiative transcends board transformation, establishing a new benchmark for organizational excellence."
	              ),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-wob-module-1-event-report-index-js-e6709f1a1cf31690c5f4.js